import whiteStarPic from '@/assets/images/white-star.png';

export default function More() {
  return (
    <div className="py-16 hidden">
      <div className="flex items-center gap-3 mb-12">
        <img src={whiteStarPic} alt="Star" className="h-[24px] sm:h-[28px] md:h-[32px] lg:h-[36px] w-auto" />
        <h2 className="text-3xl font-bold">更多服务</h2>
      </div>
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gray-900 p-6 rounded-xl">
            <h3 className="text-xl font-bold mb-4">投资咨询</h3>
            <p className="text-gray-300 mb-4">
              我们的专业团队为您提供个性化的投资咨询服务，帮助您制定合适的投资策略。
            </p>
            <button className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition">
              预约咨询
            </button>
          </div>

          <div className="bg-gray-900 p-6 rounded-xl">
            <h3 className="text-xl font-bold mb-4">研究报告</h3>
            <p className="text-gray-300 mb-4">
              定期发布行业研究报告，深入分析市场趋势和投资机会。
            </p>
            <button className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition">
              查看报告
            </button>
          </div>

          <div className="bg-gray-900 p-6 rounded-xl">
            <h3 className="text-xl font-bold mb-4">投资者教育</h3>
            <p className="text-gray-300 mb-4">
              提供专业的投资者教育资源，帮助您更好地理解投资市场。
            </p>
            <button className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition">
              开始学习
            </button>
          </div>

          <div className="bg-gray-900 p-6 rounded-xl">
            <h3 className="text-xl font-bold mb-4">活动参与</h3>
            <p className="text-gray-300 mb-4">
              参与我们的线下活动，与行业专家面对面交流。
            </p>
            <button className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition">
              查看活动
            </button>
          </div>
        </div>

        <div className="mt-12 bg-gray-900 p-8 rounded-xl">
          <h3 className="text-2xl font-bold mb-6">联系我们</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-semibold mb-4">联系方式</h4>
              <div className="space-y-3 text-gray-300">
                <p>电话：+1 (555) 123-4567</p>
                <p>邮箱：contact@polaris-invest.com</p>
                <p>地址：123 Innovation Street, Tech City, TC 12345</p>
              </div>
            </div>
            <div>
              <h4 className="font-semibold mb-4">关注我们</h4>
              <div className="flex gap-4">
                <button className="bg-gray-800 p-3 rounded-full hover:bg-gray-700 transition">
                  <span className="sr-only">Twitter</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </button>
                <button className="bg-gray-800 p-3 rounded-full hover:bg-gray-700 transition">
                  <span className="sr-only">LinkedIn</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-.88-.016-2.005-1.22-2.005-1.22 0-1.405.953-1.405 1.94v5.669h-3v-11h2.85v1.626h.041c.552-1.046 1.903-1.75 3.917-1.75 4.19 0 4.916 2.757 4.916 6.34v5.684z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="test-container">
        <div className="text">content</div>
      </div>
    </div>
  );
}
